import { useEffect, useRef, useState } from 'react'
import { useGunMode } from './gun-mode'

export function useGunControls({
  canAutoSubmitNow,
  onInsert,
  onSubmit,
  toast
}) {
  // Sumideros:
  // - sink (contentEditable) para PC sin Enter
  // - input (opcional) para móviles (ScanKey, etc.)
  const scanSinkRef = useRef(null)
  const scanInputRef = useRef(null)

  const [gunMode, setGunMode] = useState(false)
  const [gunDefaultEvent, setGunDefaultEvent] = useState('query')
  const [gunAutoSubmit, setGunAutoSubmit] = useState(false)

  const [showOfficeTooltip, setShowOfficeTooltip] = useState(false)
  const tipTimeoutRef = useRef(null)

  useGunMode({
    enabled: gunMode,
    autoSubmit: gunAutoSubmit,
    defaultEvent: gunDefaultEvent,
    canAutoSubmitNow,
    onInsert,
    onSubmit,
    toast,
    idleMs: 300,
    scanSinkRef,   // ⬅ PC sin Enter
    scanInputRef,  // ⬅ móviles (si los usas)
  })

  const blockOfficeSelectorEvents = {
    onKeyDown: (e) => {
      if (!gunMode) return
      if (e.key !== 'Tab') {
        e.preventDefault()
        e.stopPropagation()
      }
    },
    onBeforeInput: (e) => {
      if (!gunMode) return
      e.preventDefault()
      e.stopPropagation()
    },
    onPaste: (e) => {
      if (!gunMode) return
      e.preventDefault()
      e.stopPropagation()
    },
    onFocusCapture: (e) => {
      if (!gunMode) return
      if (typeof e.target.blur === 'function') e.target.blur()
      e.preventDefault()
      e.stopPropagation()
    },
    onMouseEnter: () => {
      if (!gunMode) return
      setShowOfficeTooltip(true)
    },
    onMouseLeave: () => {
      if (!gunMode) return
      setShowOfficeTooltip(false)
      if (tipTimeoutRef.current) {
        clearTimeout(tipTimeoutRef.current)
        tipTimeoutRef.current = null
      }
    }
  }

  const handleOverlayClick = () => {
    if (!gunMode) return
    setShowOfficeTooltip(true)
    if (tipTimeoutRef.current) clearTimeout(tipTimeoutRef.current)
    tipTimeoutRef.current = setTimeout(() => {
      setShowOfficeTooltip(false)
      tipTimeoutRef.current = null
    }, 2000)
  }

  useEffect(() => {
    return () => {
      if (tipTimeoutRef.current) clearTimeout(tipTimeoutRef.current)
    }
  }, [])

  return {
    gunMode,
    setGunMode,
    gunDefaultEvent,
    setGunDefaultEvent,
    gunAutoSubmit,
    setGunAutoSubmit,
    showOfficeTooltip,
    blockOfficeSelectorEvents,
    handleOverlayClick,

    // export refs para montarlos en el DOM
    scanSinkRef,
    scanInputRef,
  }
}